import * as angular from "angular";
import {IController} from "angular";

export class labelsTableCtrl implements IController {

  labels: any;
  onEdit: Function;
  onActiveChange: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.labels')
  .component('labelsTable', {
    bindings: {
      labels: '<',
      onEdit: '&',
      onActiveChange: '&'
    },
    template: require('./labels-table.html').default,
    controller: labelsTableCtrl
  });
